import React from 'react';
import glamorous from 'glamorous';

import { Container } from './Layout';
import me from '../images/me.png';

export default () => {
  return (
    <HeaderContainer>
      <ImgWrapper>
        <img src={me} alt="Taylor Fuqua" />
      </ImgWrapper>

      <Container>
        <CallToAction>
          <h1>Taylor Fuqua</h1>
          <h2>Web Developer</h2>
        </CallToAction>
      </Container>
    </HeaderContainer>
  );
};

const HeaderContainer = glamorous.div({});

const ImgWrapper = glamorous.div({
  maxWidth: '125px',
  margin: '50px auto 20px',

  '& img': {
    borderRadius: '50%',
    width: '100%',
    height: 'auto',
    verticalAlign: 'middle'
  }
});

const CallToAction = glamorous.div({
  textAlign: 'center',
  maxWidth: '500px',
  margin: '10px auto 40px',
  borderBottom: '1px solid #eee',

  '& h1': {
    margin: '0 0 10px',
    fontWeight: '400'
  },
  '& h2': {
    color: '#888',
    fontSize: '22px',
    margin: '0 0 10px',
    fontWeight: '400'
  }
});



// WEBPACK FOOTER //
// ./src/components/Header.js